import update from 'immutability-helper'
import { INITIAL_STATE } from './constants'
import * as types from './actionTypes'

const rootReducer = ( state = INITIAL_STATE, action ) => {
  switch ( action.type ) {
  case types.EXAMPLE:
    return update( state, {
      example: {
        $set: action.payload
      }
    })
  default:
    return state
  }
}

export default rootReducer
